<template>
  <el-dialog
    ref="workViewerDialog"
    :title="title"
    :visible.sync="config.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="!isDesktop"
    :show-close="false"
    :top="marginTop"
    custom-class="pop_page headless workviewer"
  >
    <div class="header" style="background:none;" :class="{'padding-top12 padding-left4 padding-right8': isDesktop, 'padding-top8': !isDesktop}">
      <div class="float-left padding-left4 padding-top4">
        <div v-if="!config.loading">
          <div v-if="!isDesktop" class="float-left">
            <el-button class="tap-btn iconfont my-back size20" @click="close()" />
            &nbsp;
          </div>
          <!-- <div class="float-left padding-left12" @click="emit('goto', ['user', { userid: work.userid } ])">
            <span v-if="!(users[work.userid] && users[work.userid].avatar)" class="el-avatar el-avatar--circle noavatar" :class="{'large': isDesktop, 'medium': !isDesktop}">
              <i class="iconfont my-man" />
            </span>
            <el-avatar v-if="(users[work.userid] && users[work.userid].avatar)" :size="isDesktop ? 42 : 32" :src="getAvatar(work.userid)" />
          </div>
          <div class="float-left white" :class="{'padding12': isDesktop, 'padding8': !isDesktop}" @click="emit('goto', ['user', { userid: work.userid } ])">
            {{ (users[work.userid]) ? users[work.userid].nickname : view.anonymity }}
          </div>
          <div class="float-left" :class="{'padding-top4': isDesktop}">
            <el-button v-if="(followState[work.userid] === 0)" class="size12 opacity-bg" @click="unfollow(work.userid)">{{ $t('i.hadFollow') }}</el-button>
            <el-button v-if="(followState[work.userid] === 1)" class="size12 opacity-bg" @click="unfollow(work.userid)">{{ $t('i.followEach') }}</el-button>
            <el-button v-if="(followState[work.userid] !== 0 && followState[work.userid] !== 1)" class="size12 opacity-bg" @click="follow(work.userid)">{{ $t('i.follow') }}</el-button>
          </div> -->
        </div>
      </div>
      <div class="float-right">
        <el-button class="tap-btn" @click="handle('workActionSheet')">
          <i class="iconfont my-dot-more size24" />
        </el-button>
        <el-button v-if="isDesktop" class="tap-btn" @click="close()">
          <i class="iconfont my-close size24" />
        </el-button>
      </div>
    </div>
    <div
      v-loading="config.loading"
      :element-loading-text="$t('i.rendin')"
      shadow="never"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      class="previewArea"
      :style="previewAreaStyle"
    >
      <img
        v-show="false"
        id="image"
        ref="image"
        :src="blankImage"
      >
      <voxel-viewer
        v-if="opts.d3 && config.show"
        ref="voxViewer"
        :state="state"
        :width="width"
        :height="height"
        :sky-styleid="0"
        :fixpos="-1"
        @receive="(event) => emit('handle', event)"
      />
    </div>
    <div style="position: absolute;text-align: center;z-index: 99;" :style="{'top': isDesktop ? '15px' : '4px', height: '50px', 'left': isDesktop ? '90px' : '60px', width: 'calc(100% - ' + (isDesktop ? 180 : 120) + 'px)'}">
      <el-row class="margin-bottom4 margin-top4 min-button" style="overflow-x: auto;">
        <el-button-group v-if="work.type < 2" class="my-button-group">
          <!-- <el-button v-if="work.type" :key="2" size="small" class="opacity-bg" style="height:32px;" :type="opts.workTypeid === 2 ? 'light' : ''" @click="setWorkType(2)">{{ $t('i.originImage') }}</el-button> -->
          <el-button v-for="workType in workTypes" :key="workType.id" size="small" class="opacity-bg" style="height:32px;" :type="opts.workTypeid === workType.id ? 'light' : ''" @click="setWorkType(workType.id)">{{ workType.label }}</el-button>
        </el-button-group>
        <el-button-group v-if="work.type >= 2" class="my-button-group">
          <el-button v-for="(assetTitle, assetid) in assetTypes" v-show="ifShowAssetType(assetid, assets[assetid])" :key="assetid" size="small" class="opacity-bg" style="height:32px;" :type="data.diyType === assetid ? 'light' : ''" @click="loadAsset(assetid, 0, true)">{{ assetTitle }}</el-button>
        </el-button-group>
      </el-row>
    </div>
    <div style="position: absolute;text-align: center;" :style="{'top': '60px', height: '50px', 'padding-left': '4px', width: ' calc(100% - ' + (isDesktop ? 28 : 8) + 'px)'}">
      <el-button v-if="canPlay && !playing" class="box32 padding4 opacity-bg margin-left4" @click="() => start()">
        <i class="iconfont my-play size20" :title="$t('i.play')" />
      </el-button>
      <el-button v-if="canPlay && playing" class="box32 padding4 opacity-bg margin-left4" type="light" @click="() => stop()">
        <i class="iconfont my-stop size20" :title="$t('i.stop')" />
      </el-button>
      <!-- <el-button v-if="canPlay && !playing" :disabled="playing" class="box32 opacity-bg padding4 margin-left4" @click="() => pre()">
        <i class="iconfont my-pre size20" :title="$t('i.pre')" />
      </el-button>
      <el-button v-if="canPlay && !playing" :disabled="playing" class="box32 opacity-bg padding4 margin-left4" @click="() => next()">
        <i class="iconfont my-next size20" :title="$t('i.next')" />
      </el-button> -->
      <el-button v-if="data.images && data.images.length > 1" class="box32 opacity-bg padding4 margin-left4" @click="() => preImage()">
        <i class="iconfont my-pre size20" :title="$t('i.pre')" />
      </el-button>
      <el-button v-if="data.images && data.images.length > 1" class="box32 opacity-bg padding4 margin-left4" @click="() => nextImage()">
        <i class="iconfont my-next size20" :title="$t('i.next')" />
      </el-button>
    </div>
    <div v-if="!showInfo && !publishid" style="text-align: center;z-index: 96;" class="mid-bottom" :style="{'position': isDesktop ? 'absolute' : 'fixed', height: '34px', 'width': '156px', left: 'calc((100% - 156px) / 2)'}">
      <el-button v-if="work.type === 2 || work.type === 7" class="opacity-bg" style="padding: 8px 16px;margin-bottom: 0;" @click="openBrickyViewer('createPuzzle')">
        <i class="iconfont my-diy margin-right8 green" />
        <span class="green">
          <span>{{ $t('i.createPuzzle') }}</span>
        </span>
      </el-button>
      <el-dropdown v-if="!(work.type === 2 || work.type === 7)" trigger="click" placement="top-start" @command="(e) => openBrickyViewer(e)">
        <el-button class="opacity-bg" style="padding: 8px 16px;margin-bottom: 0;">
          <i class="iconfont my-diy margin-right8 green" />
          <span class="green">{{ $t('i.customGoods') }}</span>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="my-dropdown custom-dropdown" :class="{'large': state.language !== 'zh'}">
          <el-dropdown-item v-if="work.type < 2" command="customBeads"><i class="iconfont margin-right8 green my-beads" /><span class="green">{{ $t('i.customBeads') }}</span></el-dropdown-item>
          <el-dropdown-item v-if="work.type < 2" command="customDiamond"><i class="iconfont margin-right8 green my-diamond" /><span class="green">{{ $t('i.customDiamond') }}</span></el-dropdown-item>
          <el-dropdown-item command="customBrick"><i class="iconfont margin-right8 green my-brickfy" /><span class="green">{{ $t('i.customBrick') }}</span></el-dropdown-item>
          <el-dropdown-item command="printD3"><i class="iconfont my-d3printer margin-right8 green" /><span class="green">{{ $t('i.print_d3') }}</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-if="publishid" class="right-top" :style="{'right': isDesktop ? '8px' : ''}">
      <el-button class="tap-btn opacity-bg margin-bottom8" @click="openPopPage({'type': 'publishInfo', 'publishid': publishid })">
        <i class="iconfont my-info" />
      </el-button>
      <el-button class="tap-btn opacity-bg margin-bottom8" @click="openPopPage({'type': 'publishPower', 'publishid': publishid })">
        <i class="iconfont my-crown" />
      </el-button>
      <!-- <el-button class="tap-btn opacity-bg margin-bottom8" @click="openPopPage({'type': 'publishCert', 'publishid': publishid })">
        <i class="iconfont my-blockchain" />
      </el-button> -->
      <el-button class="tap-btn opacity-bg margin-bottom8" @click="openPopPage({'type': 'nftnotice', 'publishid': publishid})">
        <i class="iconfont my-question" />
      </el-button>
    </div>
    <div v-if="!config.loading && work.workid > 0" ref="workInfo" :style="{'bottom': isDesktop ? '70px' : '', 'left': isDesktop ? '15px' : ''}" class="left-bottom" :class="{'large opacity-bg round4 padding-top4': showInfo, 'short': publishid}">
      <span v-if="!publishid" @click="emit('goto', ['user', { userid: work.userid } ])">@{{ (users[work.userid]) ? users[work.userid].nickname : view.anonymity }}</span>
      <el-button v-if="!publishid" class="tap-btn opacity-bg" @click="toggleWorkInfo">
        <i v-if="showInfo" class="iconfont my-open-down" />
        <i v-if="!showInfo" class="iconfont my-close-up" />
      </el-button>
      <span v-if="!publishid" @click="showInfo = !showInfo">
        <br>
        <!-- <span v-if="work.original" class="tag opacity-bg">{{ $t('i.origin') }}</span> <span v-if="work.best" class="tag opacity-bg">{{ $t('i.recomman') }}</span> -->
        {{ work.name || '' }} {{ getWorkTags() }}
        <br>{{ work.info || '' }}
        <br>{{ formateTime(work.updateTime) }} <i v-if="workCount.view_count" class="iconfont my-eye tiny" /> <span class="num">{{ workCount.view_count ? formateNums(workCount.view_count) : '' }}</span>
      </span>
      <span v-if="publishid && !config.loading">
        {{ publish.name || work.name }}
        <span v-if="publish.amount" class="right yellow size14">
          ¥{{ formateMoney(publish.amount) }}
        </span>
        <br>
        <span v-if="publish.seriesid && series[publish.seriesid] && series[publish.seriesid].name" class="tag opacity-bg white">{{ series[publish.seriesid].name }}</span>
        <span v-if="publish.total" class="tag bg-blue white margin-left8">{{ $t('i.numLimit', { total: publish.total }) }}</span>
      </span>
    </div>
    <div v-if="!config.loading" class="right-bottom-btns">
      <el-button v-if="publishid && (work.type === 2 || work.type === 7)" class="opacity-bg" @click="openBrickyViewer('createPuzzle')">
        <i class="iconfont my-diy green" />
        <span class="green"> {{ $t('i.createPuzzle') }}</span>
      </el-button>
      <el-dropdown v-if="publishid && !(work.type === 2 || work.type === 7)" trigger="click" placement="top-start" @command="(e) => openBrickyViewer(e)">
        <el-button class="opacity-bg">
          <i class="iconfont my-diy green" />
          <span class="green"> {{ $t('i.customGoods') }}</span>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="my-dropdown custom-dropdown">
          <el-dropdown-item v-if="work.type < 2" command="customBeads"><i class="iconfont margin-right8 green my-beads" /><span class="green">{{ $t('i.customBeads') }}</span></el-dropdown-item>
          <el-dropdown-item v-if="work.type < 2" command="customDiamond"><i class="iconfont margin-right8 green my-diamond" /><span class="green">{{ $t('i.customDiamond') }}</span></el-dropdown-item>
          <el-dropdown-item command="customBrick"><i class="iconfont margin-right8 green my-brickfy" /><span class="green">{{ $t('i.customBrick') }}</span></el-dropdown-item>
          <el-dropdown-item command="printD3"><i class="iconfont my-d3printer margin-right8 green" /><span class="green">{{ $t('i.print_d3') }}</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="publishid && publish.paradrop" class="opacity-bg" @click="createOrder(publish.publishid, 5, publish.paradrop_state === 1 && !orderState[5], publish.paradrop_state)">
        <i class="iconfont my-airplane" :class="{'green': publish.paradrop_state === 1 && !orderState[5], 'color-66': publish.paradrop_state === -1 || orderState[5]}" />
        <span v-if="publish.paradrop_state === 1 && orderState[5]" class="color-66">{{ $t('i.received') }}</span>
        <span v-if="publish.paradrop_state === 1 && !orderState[5]" class="green">{{ $t('i.claimAirdrop') }}</span>
        <span v-if="publish.paradrop_state === -1" class="color-66">{{ publish.paradrop_tag[0] }}</span>
        <span v-if="publish.paradrop_state === 0">
          <count-down v-if="publish.paradrop_tag[2]" :current-time="publish.now" :start-time="publish.paradrop_tag[2]" :end-time="publish.paradrop_tag[2]" @start_callback="countDownStartCb()" @end_callback="() => {}" />
          <span v-if="!publish.paradrop_tag[2] && publish.paradrop_tag[0]">{{ publish.paradrop_tag[0] }}</span>
        </span>
      </el-button>
      <el-button v-if="publishid && publish.compound" class="opacity-bg" @click="createOrder(publish.publishid, 4, publish.compound_state === 1 && !orderState[4], publish.compound_state)">
        <i class="iconfont my-compound" :class="{'green': publish.compound_state === 1 && !orderState[4], 'color-66': publish.compound_state === -1 || orderState[4]}" />
        <span v-if="publish.compound_state === 1 && orderState[4]" class="color-66">{{ $t('i.alreadyCast') }}</span>
        <span v-if="publish.compound_state === 1 && !orderState[4]" class="green">{{ $t('i.wantCast') }}</span>
        <span v-if="publish.compound_state === -1" class="color-66">{{ publish.compound_tag[0] }}</span>
        <span v-if="publish.compound_state === 0">
          <count-down v-if="publish.compound_tag[2]" :current-time="publish.now" :start-time="publish.compound_tag[2]" :end-time="publish.compound_tag[2]" @start_callback="countDownStartCb()" @end_callback="() => {}" />
          <span v-if="!publish.compound_tag[2] && publish.compound_tag[0]">{{ publish.compound_tag[0] }}</span>
        </span>
      </el-button>
      <el-button v-if="publishid && publish.sell_tag" class="opacity-bg" @click="createOrder(publish.publishid, publish.order_type, publish.btnState, publish.sell_state)">
        <i v-if="!publish.countDown" class="iconfont my-pay" :class="{'green': publish.btnState, 'color-66': publish.sell_state == -1 && !publish.btnState}" />
        <span v-if="!publish.countDown" :class="{'green': publish.btnState, 'color-66': publish.sell_state == -1 && !publish.btnState}">{{ publish.btnTxt }}</span>
        <count-down v-if="publish.countDown" :pre-text="publish.sell_tag[3] || ''" :current-time="publish.now" :start-time="publish.sell_tag[2]" :end-time="publish.sell_tag[2]" @start_callback="countDownStartCb()" @end_callback="() => {}" />
      </el-button>
    </div>
    <div slot="footer" :style="{'width': (isDesktop ? width : width - 15) + 'px'}">
      <el-row class="btns-bar">
        <el-col :span="5">
          <el-badge :value="formateNums(workCount.post_count)" :hidden="!workCount.post_count">
            <el-button class="padding8 opacity-bg" @click="openComment()">
              <i class="iconfont my-comments size20" />
            </el-button>
          </el-badge>
        </el-col>
        <el-col :span="5">
          <el-badge :value="formateNums(workCount.praise_count)" :hidden="!workCount.praise_count">
            <el-button class="padding8 opacity-bg" @click="() => praiseIt(work.workid)">
              <i class="iconfont size20" :class="{ 'my-praise-fill': workCount.praise_state, 'my-praise-blank': !workCount.praise_state }" />
            </el-button>
          </el-badge>
        </el-col>
        <el-col :span="5">
          <el-badge :value="formateNums(workCount.favor_count)" :hidden="!workCount.favor_count">
            <el-button class="padding8 opacity-bg" @click="() => favorIt(work.workid)">
              <i class="iconfont size20" :class="{ 'my-star': workCount.favor_state, 'my-blank-star': !workCount.favor_state }" />
            </el-button>
          </el-badge>
        </el-col>
        <el-col :span="5">
          <el-badge v-if="!(work.type === 2 || work.type === 7)" :value="formateNums(workCount.diy_count)" :hidden="!workCount.diy_count">
            <el-dropdown trigger="click" placement="top-start" @command="(e) => openBrickyViewer(e)">
              <el-button class="iconfont my-diy size20 padding8 opacity-bg" :title="$t('i.customGoods')" />
              <el-dropdown-menu slot="dropdown" class="my-dropdown custom-dropdown">
                <el-dropdown-item v-if="work.type < 2" command="customBeads"><i class="iconfont margin-right8 green my-beads" /><span class="green">{{ $t('i.customBeads') }}</span></el-dropdown-item>
                <el-dropdown-item v-if="work.type < 2" command="customDiamond"><i class="iconfont margin-right8 green my-diamond" /><span class="green">{{ $t('i.customDiamond') }}</span></el-dropdown-item>
                <el-dropdown-item command="customBrick"><i class="iconfont margin-right8 green my-brickfy" /><span class="green">{{ $t('i.customBrick') }}</span></el-dropdown-item>
                <el-dropdown-item command="printD3"><i class="iconfont my-d3printer margin-right8 green" /><span class="green">{{ $t('i.print_d3') }}</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-badge>
          <el-badge v-if="work.type === 2 || work.type === 7" :value="formateNums(workCount.idea_count)" :hidden="!workCount.idea_count">
            <el-button class="iconfont my-design size20 padding8 opacity-bg" :title="$t('i.secondCreation')" @click="toDesign" />
          </el-badge>
        </el-col>
        <el-col :span="5">
          <el-dropdown trigger="click" placement="top-start" @command="handle">
            <el-badge :value="formateNums(workCount.down_count)" :hidden="!workCount.down_count">
              <el-button class="iconfont my-out size20 padding8 opacity-bg" :disabled="playing" :title="$t('i.more')" />
            </el-badge>
            <el-dropdown-menu slot="dropdown" class="my-dropdown">
              <el-dropdown-item v-if="!showSimpleExportBtn" command="exportPixel"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportPixel') }}</div></el-dropdown-item>
              <el-dropdown-item v-if="!showSimpleExportBtn" command="exportGridy"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportGridy') }}</div></el-dropdown-item>
              <el-dropdown-item v-if="!showSimpleExportBtn" command="exportBrick"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportPuzzle') }}</div></el-dropdown-item>
              <!-- <el-dropdown-item v-if="!showSimpleExportBtn" command="exportAdvance"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.advancedExport') }}</div></el-dropdown-item> -->
              <el-dropdown-item v-if="editType" command="publishWork" :divided="!showSimpleExportBtn"> <i class="iconfont my-edit" /> {{ editType === 1 ? $t('i.edit') : $t('i.publish') }}...</el-dropdown-item>
              <el-dropdown-item command="share" :divided="!editType"> <i class="iconfont my-share-out" /> {{ $t('i.copyLink') }}</el-dropdown-item>
              <el-dropdown-item command="pop"> <i class="iconfont my-pop" /> {{ $t('i.createShareImage') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-show="false" ref="share-url" class="clipboard" :data-clipboard-text="' ' + getInfo(work) + ' ' + mainHost + '#/?mod=workViewer&workid=' + work.workid" @click="shareIt(work.workid)" />
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import { mixins } from '@/mixins/common'
import utils from '@/js/utils'
import service from '@/js/service'
import conf from '@/js/conf/conf'
import GRIDY from '@/js/sdk/GridySDK'
import voxelViewer from '@/components/viewer/voxelViewer'
import countDown from '@/components/countDown'
import blankImage from '@/assets/blank.png'
import ClipboardJS from 'clipboard'
export default {
  components: {
    voxelViewer,
    countDown
  },
  mixins: [mixins],
  props: {},
  data() {
    let width, height
    if (this.state.platform.type === 'desktop') {
      width = utils.popWidth()
      height = utils.popHeight()
    } else {
      width = utils.width()
      height = utils.height()
    }
    const palette = conf.palette()
    const defaultOpts = {
      x: 0,
      y: 0,
      initScale: 1,
      defaultGridSize: 8,
      workTypeid: 0,
      gridSize: 8,
      fillShape: '',
      brickfy: false,
      roundTile: false,
      d3: true,
      diy: false,
      diyType: '',
      assetid: ''
    }
    return {
      mainHost: conf.hosts().mainHost,
      inited: false,
      initingWorkData: false,
      sceneIdx: 0,
      playing: false,
      work: {},
      originWork: {},
      publishid: 0,
      publish: {},
      orderState: {},
      count: 0,
      sto: null,
      imgEl: null,
      voxelViewerEl: null,
      GRIDYXLS: null,
      GRIDYLXF: null,
      GRIDYPAPER: null,
      GRIDYBOM: null,
      GRIDY: null,
      touchEndLock: false,
      defaultOpts: defaultOpts,
      opts: utils.deepClone(defaultOpts),
      width: width,
      height: height,
      blankImage: blankImage,
      palette: palette,
      sceneObj: '',
      workTypes: conf.workTypes(),
      pixelOnly: true,
      showInfo: false,
      textureShow: true
    }
  },
  computed: {
    config() {
      return this.view.workViewer
    },
    data() {
      return this.config.data
    },
    assets() {
      const types = {
        origin_img: null,
        img: null,
        views: null,
        d3: null,
        vox: null,
        chain_brick: null,
        lego_brick: null
      }
      const paint = (this.work && this.work.paint) ? this.work.paint : {}
      if (paint && paint._attachments && paint._attachments.length) {
        // 来源；0=文生图; 1=图生图; 2=文生3D; 3=图生3D; 4=文生体素; 5=图生体素; 6=3D转体素;
        if (paint.origin === 1) {
          types['origin_img'] = paint._attachments
        } else if (paint.origin === 3 || paint.origin === 5) {
          types['views'] = paint._attachments
        } else {
          for (const i in paint._attachments) {
            const attachment = paint._attachments[i]
            types[attachment[0]] = attachment
          }
        }
      }
      if (paint && paint._assets && paint._assets.length) {
        const img = []
        for (const i in paint._assets) {
          const asset = paint._assets[i]
          if (asset[0] === 'img') {
            img.push(asset)
          } else {
            types[asset[0]] = asset
          }
        }
        if (img.length) {
          types['img'] = img
        }
      }
      return types
    },
    assetTypes() {
      return {
        origin_img: this.$t('i.originImage'),
        img: this.$t('i.pixel'),
        views: this.$t('i.three_views'),
        d3: this.$t('i.type_d3s'),
        vox: this.$t('i.type_vox'),
        chain_brick: this.$t('i.type_vox'), // 串联积木模型，对外展示时叫体素模型
        lego_brick: this.$t('i.lego_block') // 乐高积木模型，对外展示时叫体素模型
      }
    },
    title() {
      return this.config.title
    },
    previewAreaStyle() {
      return { 'width': this.width + 'px', 'height': this.height + 'px', 'background': '#000000', 'overflow': 'hidden', 'text-align': 'center' }
    },
    scenes() {
      return (this.work && this.work.canvas) ? this.work.canvas.scenes : []
    },
    canPlay() {
      return this.scenes.length > 1
    },
    series() {
      return this.state.series || {}
    },
    publishes() {
      return this.state.publishes || {}
    },
    followState() {
      return this.state.followState || {}
    },
    workCount() {
      return this.state.workCount || {}
    },
    showSimpleExportBtn() {
      return this.work && this.work.type >= 3
    },
    editType() {
      // 0=无权限; 1=编辑; 2发布;
      let type = 0
      if (this.loginUserId) {
        if (this.work.workid) {
          type = (this.work.userid === this.loginUserId || this.loginUserId < 10000) ? 1 : 0
        }
      }
      return type
    }
  },
  mounted() {
    if (this.config.show) {
      this.loading(true)
      // console.error('workViewer load', this.data, this.opts)
      this.init(() => {
        this.opts = utils.deepClone(this.defaultOpts)
        this.getWorkData(this.data.workid || this.config.workid, this.data.userid, (work) => {
          if (!work) {
            this.goto('index')
            return
          }
          this.work = work
          this.originWork = utils.deepClone(work)
          service.incCount(this.loginUserId, 'work_view')
          this.getWorkCount(work.workid)
          this.GRIDY = new GRIDY()
          this.GRIDY.setFile(work)
          this.opts.paletteId = work.paletteId || 'originPalette'
          // 像素画模式
          if (this.pixelOnly) {
            this.opts.fillShape = ''
            this.opts.workTypeid = 0
          } else {
            this.opts.fillShape = work.fillShape
            this.opts.workTypeid = work.type === 1 ? 2 : 0
          }
          this.loadAsset()
        })
      })
    } else {
      if (this.imgEl) {
        this.imgEl.onload = null
        this.imgEl.onerror = null
      }
      this.inited = false
    }
  },
  methods: {
    ifShowAssetType(assetid, show) {
      // 串联积木模型、体素模型、乐高积木模型，对外展示时叫体素模型，所以当diyType不是串联积木模型时，也显示体素模型（主要显示串联积木模型）
      if (assetid === 'chain_brick' || assetid === 'vox' || assetid === 'lego_brick') {
        return this.data.diyType === assetid || (this.data.diyType !== assetid && assetid === 'chain_brick')
      } else {
        return !!show
      }
    },
    load(useCachedChunks = true) {
      this.setImageStyle()
      if (this.opts.d3) {
        const work = this.GRIDY.getFile()
        this.voxelViewerEl.setWork(work)
        // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
        if (this.work.type >= 2) {
          if (this.work.type === 3) {
            this.voxelViewerEl.setDiyMod('d3')
          } else if (this.work.type === 4) {
            this.voxelViewerEl.setDiyMod('vox')
          } else if (this.work.type === 5) {
            this.voxelViewerEl.setDiyMod('chain_brick')
          } else if (this.work.type === 6) {
            this.voxelViewerEl.setDiyMod('lego_brick')
          } else {
            this.voxelViewerEl.setDiyMod('')
          }
        } else {
          if (this.opts.workTypeid === 2) {
            // 拼图展示
            this.voxelViewerEl.setDiyMod('brick', { frameId: 'whiteWhite' })
          } else {
            this.voxelViewerEl.setDiyMod('')
          }
        }
        this.voxelViewerEl.launch(() => {
          this.voxelViewerEl.draw(this.imgEl, () => {
            this.loading(false)
          }, useCachedChunks)
        })
      } else {
        this.loading(false)
      }
    },
    init(cb) {
      if (this.inited) {
        cb && cb()
        return
      }
      this.imgEl = this.$refs.image
      this.voxelViewerEl = this.$refs.voxViewer
      if (!this.imgEl || !this.voxelViewerEl) {
        setTimeout(() => {
          this.init(cb)
        }, 10)
        return
      }
      this.imgEl.onload = this.load
      this.imgEl.onerror = this.load
      this.inited = true
      cb && cb()
    },
    showTab(id) {
      if (this.work.type === 1) {
        return id !== 0
      } else {
        return id !== 2
      }
    },
    close() {
      if (this.playing) this.stop()
      this.closePop(this.config)
    },
    loading(show, tip, parentLoading = false, cb) {
      if (!parentLoading) this.config.loading = show
      if (!show || parentLoading) {
        this.emit('loading', [!!show, tip || this.$t('i.rendin')])
      }
      if (cb) {
        setTimeout(cb, 100)
      }
    },
    openGridyViewer(diyType) {
      let type = ''
      // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
      if (this.work.type === 2 || this.work.type === 7) {
        const image_url = service.getCosUrl(this.work.data.image_url, 'paint', this.work.public_at)
        this.emit('openImg', [this.work.data.type, image_url, this.work.data.paintid])
        return
      } else if (this.work.type > 2) {
        if (this.work.type === 3) {
          diyType = 'd3'
        } else if (this.work.type === 4) {
          diyType = 'vox'
        } else if (this.work.type === 5) {
          diyType = 'chain_brick'
        } else if (this.work.type === 6) {
          diyType = 'lego_brick'
        } else {
          diyType = ''
        }
        type = 'voxelViewer'
      } else {
        diyType = this.opts.workTypeid === 2 ? 'brick' : diyType
        if (this.opts.workTypeid === 2) {
          this.work.type = 1
          this.work.paletteId = 'brickfy'
        }
        type = 'workViewer'
      }
      this.emit('openGridyViewer', [{ data: { work: this.work, type: type, diyType: diyType, workTypeid: this.opts.workTypeid, fillShape: '' }}])
    },
    openBrickyViewer(customType = '') {
      const work = this.GRIDY.getFile()
      if (work.workid) this.emit('workCount', [work.workid, 'diy'])
      if (work.type === 2 || this.work.type === 7) {
        this.GRIDY.imageLoader(service.getCosUrl(work.data.image_url, 'paint', work.public_at), (base64) => {
          const file = utils.blobToFile(utils.base64ToBlob(base64), work.name, 'image/png')
          this.emit('openCropImage', [{ data: { file: file, diyType: 'brick', showOriginImage: true }}])
        })
      } else {
        let skuId = ''
        let paletteId = ''
        let diyType = ''
        let type = ''
        let fillShape = ''
        let name = ''
        let img = ''
        // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
        if (work.type === 2 || this.work.type === 7) {
          diyType = 'brick'
          fillShape = 'default'
          name = work.name
          img = service.getCosUrl(work.data.image_url, 'paint', work.public_at) || ''
        } else if (work.type >= 2) {
          if (customType === 'printD3' || customType === 'customBrick') {
            // 体素模型要3D打印或定制积木 或 3D模型要定制积木，则使用串联积木模型最新版本作为作品数据
            // console.error('openBrickyViewer customType', customType, work.type)
            if (work.type === 4 || (customType === 'customBrick' && work.type === 3)) {
              diyType = 'chain_brick'
              paletteId = customType === 'printD3' ? 'D3' : 'BLOKY'
              if (work.paint && work.paint.assets && work.paint.assets[diyType] && work.paint.assets[diyType].length) {
                const asset = work.paint.assets[diyType][work.paint.assets[diyType].length - 1]
                work.data = {
                  type: diyType,
                  image_url: service.getCosUrl(asset.key_preview, 'paint', work.paint.update_at),
                  url: service.getCosUrl(asset.key, 'paint', work.paint.update_at),
                  paintid: work.paint.paintid
                }
                work.type = 5
              }
            } else {
              if (customType === 'printD3') {
                diyType = 'd3'
                paletteId = 'D3'
              } else if (customType === 'customBrick') {
                diyType = 'chain_brick'
                paletteId = 'BLOKY'
              }
            }
          } else {
            if (work.type === 3) {
              diyType = 'd3'
              paletteId = 'D3'
            } else if (work.type === 4) {
              diyType = 'vox'
              paletteId = 'BLOKY'
            } else if (work.type === 5) {
              diyType = 'chain_brick'
              paletteId = 'BLOKY'
            } else if (work.type === 6) {
              diyType = 'lego_brick'
              paletteId = 'BLOKY'
            } else {
              diyType = ''
            }
          }
          type = 'voxelViewer'
        } else {
          diyType = 'brick'
          type = 'workViewer'
          // SKU：8000=乐高积木画 9000=百乐酷积木画 10001=串联积木画 10002=钻石画 10003=拼豆豆 20001=定制积木 20002=3D打印
          if (customType === 'customBeads') {
            paletteId = 'BEADS'
            skuId = '10003'
          } else if (customType === 'customDiamond') {
            paletteId = 'DIAMOND'
            skuId = '10002'
          } else if (customType === 'printD3') {
            skuId = '20002'
            paletteId = 'D3'
          }
        }
        this.emit('openBrickyViewer', [{ data: { skuId: skuId, colorfyId: '', paletteId: paletteId, customType: customType, img: img, name: name, work: work, type: type, diyType: diyType, fillShape: fillShape, canback: false }}])
      }
      // setTimeout(this.close, 1000)
    },
    // 二次创作
    toDesign() {
      this.emit('workCount', [this.work.workid, 'idea'])
      this.emit('traceEvent', ['toDesign'])
      this.openGridyViewer()
      setTimeout(this.close, 1000)
    },
    // 设置作品类型
    setWorkType(workTypeid) {
      this.opts.workTypeid = workTypeid
      let shapeid = ''
      for (const i in this.workTypes) {
        if (this.workTypes[i].id === this.opts.workTypeid) {
          shapeid = this.workTypes[i].shapeid
        }
      }
      this.emit('traceEvent', ['setWorkType_work', '', { shapeid: shapeid, workTypeid: workTypeid }])
      this.opts.paletteId = this.opts.workTypeid === 2 ? 'brickfy' : ''
      this.setShape(shapeid, false)
    },
    // 设置网格形状
    setShape(shapeid, trace = true) {
      setTimeout(() => {
        this.opts.fillShape = shapeid
        this.draw()
      }, 100)
      if (trace) this.emit('traceEvent', ['setShape', '', { shapeid: shapeid }])
    },
    viewThread(threadid) {
      this.emit('goto', ['thread', { threadid: threadid }, true])
      this.emit('traceEvent', ['viewThread', '', { threadid: threadid }])
    },
    openComment() {
      this.view.comment.work = this.work
      this.goto('comment')
    },
    // 获取发行信息
    getPublish(publishid, cb) {
      service.get('publish', publishid, (ret, type) => {
        if (type === 'success') {
          if (ret.data && ret.data.items) {
            for (var i in ret.data.items) {
              const item = ret.data.items[i]
              this.state.publishes[item.publishid] = item
            }
          }
          if (ret.data && ret.data.series) {
            for (var seriesid in ret.data.series) {
              this.state.series[seriesid] = ret.data.series[seriesid]
            }
          }
        }
        cb && cb()
      }, false)
    },
    // 获取作品计数器
    getWorkCount(workid) {
      service.get('work_count', workid, (ret, type) => {
        if (type === 'success') {
          this.state.workCount = ret.data || {}
          // console.error('workCount', this.state.workCount, ret, type)
          this.work.threadid = ret.data.threadid || 0
          if (!this.work.threadid) this.work.postid = 0
        }
      }, false)
    },
    getAttachments(item) {
      const attachment = []
      if (!item || !item.ai_params) return attachment
      if (item.ai_params.ImageUrl) {
        const img = service.getCosUrl(item.ai_params.ImageUrl, 'paint', item.update_at)
        if (img) attachment.push(['img', img, ''])
      }
      if (item.ai_params.MultiViewImages) {
        for (const i in item.ai_params.MultiViewImages) {
          const img = service.getCosUrl(item.ai_params.MultiViewImages[i].ViewImageUrl, 'paint', item.update_at)
          if (img) attachment.push(['img', img, item.ai_params.MultiViewImages[i].ViewType])
        }
      }
      if (item.ai_params.D3Url) {
        const d3 = service.getCosUrl(item.ai_params.D3Url, 'paint', item.update_at, false, false)
        const d3_image = item.ai_params.D3ImageUrl ? service.getCosUrl(item.ai_params.D3ImageUrl, 'paint', item.update_at) : ''
        if (d3) attachment.push(['d3', d3_image, d3])
      }
      return attachment
    },
    getAssets(item) {
      const asset = []
      if (!item || !item.assets) return asset
      if (item.assets.img && item.assets.img.length) {
        for (const i in item.assets.img) {
          const img = service.getCosUrl(item.assets.img[i].key, 'paint', item.update_at)
          if (img) asset.push(['img', img, img])
        }
      }
      if (item.assets.img_volc && item.assets.img_volc.length) {
        for (const i in item.assets.img_volc) {
          const img = service.getCosUrl(item.assets.img_volc[i].key, 'paint', item.update_at)
          if (img) asset.push(['img', img, img])
        }
      }
      if (item.assets.d3 && item.assets.d3.length) {
        for (const i in item.assets.d3) {
          const d3 = service.getCosUrl(item.assets.d3[i].key, 'paint', item.update_at, false, false)
          const preview = service.getCosUrl(item.assets.d3[i].key_preview, 'paint', item.update_at) || ''
          if (d3) asset.push(['d3', preview, d3])
        }
      }
      if (item.assets.vox && item.assets.vox.length) {
        for (const i in item.assets.vox) {
          const vox = service.getCosUrl(item.assets.vox[i].key, 'paint', item.update_at, false, false)
          const preview = service.getCosUrl(item.assets.vox[i].key_preview, 'paint', item.update_at) || ''
          if (vox) asset.push(['vox', preview, vox])
        }
      }
      if (item.assets.chain_brick && item.assets.chain_brick.length) {
        for (const i in item.assets.chain_brick) {
          const chain_brick = service.getCosUrl(item.assets.chain_brick[i].key, 'paint', item.update_at, false, false)
          const preview = service.getCosUrl(item.assets.chain_brick[i].key_preview, 'paint', item.update_at) || ''
          if (chain_brick) asset.push(['chain_brick', preview, chain_brick])
        }
      }
      if (item.assets.lego_brick && item.assets.lego_brick.length) {
        for (const i in item.assets.lego_brick) {
          const lego_brick = service.getCosUrl(item.assets.lego_brick[i].key, 'paint', item.update_at, false, false)
          const preview = service.getCosUrl(item.assets.lego_brick[i].key_preview, 'paint', item.update_at) || ''
          if (lego_brick) asset.push(['lego_brick', preview, lego_brick])
        }
      }
      return asset
    },
    // 网络加载作品数据
    getWorkData(workid, userid, cb) {
      if (this.loginUserId !== parseInt(userid)) userid = ''
      service.get('work_data', workid, (ret, type) => {
        if (type === 'success' && ret.data && ret.data.data) {
          const data = ret.data
          let work = {}
          if (data.type <= 1) {
            work = utils.deepClone(data.data)
            work.workid = data.workid
            work.userid = data.userid
            work.threadid = data.threadid || 0
            work.postid = data.postid || 0
            work.publish = true
            work.public = data.public || false
            work.best = data.best || false
            work.check = data.check || false
            work.flag = data.flag || false
            work.hot = data.hot || false
            work.original = data.original || false
            work.updateTime = work.updateTime || data.public_at * 1000
            work.publishid = data.publishid
          } else {
            if (data.paint) {
              data.paint._attachments = this.getAttachments(data.paint)
              data.paint._assets = this.getAssets(data.paint)
            }
            work = utils.deepClone(data)
            work.publish = true
            work.updateTime = work.updateTime || data.public_at * 1000
          }
          if (work.publishid) {
            this.getPublish(work.publishid, () => {
              if (this.state.publishes[work.publishid]) {
                this.publish = this.state.publishes[work.publishid] || {}
                this.getOrderState(work.publishid)
                this.publishid = work.publishid
              } else {
                work.publishid = 0
                this.publishid = 0
              }
            })
          }
          if (!this.users[data.userid]) {
            this.emit('getUser', [data.userid])
          }
          cb && cb(work)
        } else {
          cb && cb()
          this.loading(false)
        }
      }, false, { userid: userid }, false)
    },
    toggleWorkInfo() {
      this.showInfo = !this.showInfo
    },
    getAvatar(userid) {
      if (this.users[userid]) return this.getUserAvatar(this.users[userid])
    },
    getUserAvatar(user) {
      const ver = Math.round(new Date(user.avatar_at) / 1000)
      if (user.avatar) return service.getCosUrl(user.avatar, 'avatar', ver) || ''
    },
    // 更新数据
    updateItems() {
      const data = this.state.updateWork[this.work.workid]
      if (data) {
        for (const k in data) {
          this.file[k] = data[k]
        }
      }
      this.update()
    },
    getRelateWork(userid, workid, direction) {
      this.showInfo = false
      this.loading(true)
      direction = direction || 'down'
      const params = {
        'userid': userid,
        'workid': workid,
        'direction': direction,
        'limit': 1
      }
      service.actionGet('work_data', params, (res, type) => {
        if (type === 'success' && res && res.data && Array.isArray(res.data) && res.data.length) {
          service.incCount(this.loginUserId, 'work_view')
          this.emit('useRemoteWork', [res.data[0], true])
        } else {
          this.loading(false)
        }
      }, false, false)
    },
    countDownStartCb() {
      this.emit('getPublish')
    },
    getOrderState(publishid) {
      this.orderState = {}
      if (publishid) {
        service.actionGet('publish', { type: 'all_order_status', id: publishid }, (dt, type) => {
          if (type === 'success' && dt && dt.data) {
            for (var i in dt.data) {
              this.orderState[dt.data[i].type] = dt.data[i]
            }
          }
          this.calPublishOrderState()
          this.update()
        }, true)
      }
    },
    // order_type: 1=申购; 2=优先购; 3=发售; 4=铸造; 5=空投;
    calPublishOrderState() {
      const getState = (order_type) => {
        if (order_type === 3 || order_type === 2) {
          this.publish.btnTxt = (this.orderState[order_type] && this.orderState[order_type].pay_status === 1) ? this.$t('i.purchased') : (order_type === 3 ? this.$t('i.buyIt') : this.$t('i.preemptiveRights'))
          this.publish.btnState = !this.orderState[order_type] || this.orderState[order_type].pay_status !== 1
        } else if (order_type === 1) {
          this.publish.btnTxt = this.orderState[order_type].preorder_status === 1 ? (this.orderState[order_type].pay_status === 1 ? this.$t('i.purchased') : this.$t('i.payWin')) : (this.orderState[order_type].preorder_status === -1 ? this.$t('i.notWin') : this.$t('i.subscribed'))
          this.publish.btnState = this.orderState[order_type].preorder_status === 1 && this.orderState[order_type].pay_status !== 1
        } else if (order_type === 0) {
          this.publish.btnTxt = this.publish.order_type === 1 ? this.$t('i.wantSubscribed') : (this.publish.order_type === 2 ? this.$t('i.preemptiveRights') : this.$t('i.buyIt'))
          this.publish.btnState = true
        } else if (order_type === -1) {
          this.publish.btnTxt = this.$t('i.sellOut')
          this.publish.btnState = false
        }
      }
      this.publish.btnTxt = ''
      // sell_state 售卖状态： -1=售罄 0=不可购买 1=可购买
      if (this.publish.sell_state === 0) {
        if (this.publish.sell_tag[2]) {
          this.publish.countDown = true
          // 有申购订单
          if (this.orderState[1]) {
            this.publish.countDown = this.orderState[1].preorder_status !== 1
            getState(1)
          }
        } else {
          this.publish.btnTxt = this.publish.sell_tag[0]
          this.publish.btnState = false
        }
      } else if (this.publish.sell_state === 1) {
        if (this.publish.order_type === 1) {
          if (this.orderState[1]) {
            getState(1)
          } else {
            getState(0)
          }
        } else if (this.publish.order_type === 2) {
          if (this.orderState[2]) {
            getState(2)
          } else if (this.orderState[1]) {
            getState(1)
          } else {
            getState(0)
          }
        } else if (this.publish.order_type === 3) {
          if (this.orderState[3]) {
            getState(3)
          } else if (this.orderState[2]) {
            getState(2)
          } else if (this.orderState[1]) {
            if (this.orderState[1].preorder_status === 1) {
              getState(1)
            } else {
              getState(0)
            }
          } else {
            getState(3)
          }
        } else {
          getState(0)
        }
      } else if (this.publish.sell_state === -1) {
        getState(-1)
      }
    },
    // order_type: 1=申购; 2=优先购; 3=发售; 4=铸造; 5=空投;
    createOrder(publishid, order_type, state, sale_state) {
      if (state) {
        if (!this.loginStatus) {
          this.message('', 'login')
          return
        }
        const pay_cb = (status, pay_status) => {
          if (status) {
            this.getOrderState(publishid)
          } else if (typeof pay_status !== 'undefined' && pay_status < 0) {
            delete this.orderState[order_type]
            this.calPublishOrderState()
            this.update()
          }
        }
        if (this.orderState[order_type] && this.orderState[order_type].nft_orderid) {
          if (order_type === 1) {
            if (this.orderState[order_type].preorder_status === 1) {
              this.showPayment(this.orderState[order_type], pay_cb)
            } else if (this.orderState[order_type].preorder_status === 0) {
              this.alert(this.$t('i.waitingDraw'))
              return
            }
          } else if (order_type === 2 || order_type === 3) {
            this.showPayment(this.orderState[order_type], pay_cb)
          }
          return
        }
        const orderNow = () => {
          service.post('nft_order', { publishid: publishid, type: order_type }, (dt, type) => {
            if (type === 'success') {
              // 构造数据
              this.orderState[order_type] = { nft_status: 0, pay_status: 0, preorder_status: 0, type: order_type, amount: this.publish.amount, nft_orderid: (dt.data && dt.data.nft_orderid) ? dt.data.nft_orderid : 0 }
              this.calPublishOrderState()
              if (order_type === 1) {
                this.alert(this.$t('i.waitingDraw'))
              } else if (order_type === 2 || order_type === 3) {
                this.showPayment(this.orderState[order_type], pay_cb)
              } else if (order_type === 4) {
                this.view.pop.show = false
                this.alert(this.$t('i.castOk'))
              } else if (order_type === 5) {
                this.alert(this.$t('i.claimed'))
              }
              service.incCount(this.loginUserId, 'nft_order_type_' + order_type)
              this.update()
            } else {
              if (type === 'login') {
                this.message(dt, type)
              } else {
                this.alert(dt)
              }
            }
          }, true)
        }
        if (order_type === 4) {
          this.showCompound(orderNow)
        } else {
          orderNow()
        }
      } else {
        if (sale_state === 0) this.alert(this.$t('i.waiting'))
      }
    },
    showPayment(order, cb) {
      this.view.pop.title = this.$t('i.pay')
      this.view.pop.tip = ''
      this.view.pop.type = 'payment_nft'
      this.view.pop.data = order || {}
      this.view.pop.show = true
      this.view.pop.fn = cb
    },
    showCompound(cb) {
      this.view.pop.title = this.$t('i.casting')
      this.view.pop.tip = ''
      this.view.pop.type = 'compound'
      this.view.pop.data = this.publish
      this.view.pop.show = true
      this.view.pop.fn = cb
    },
    formateTime: utils.formateTime,
    formateNums: utils.formateNums,
    formateMoney: utils.formateMoney,
    getWorkTags() {
      if (!this.work.tags) return ''
      let tags = ''
      if (this.work.tags && this.work.tags.length) {
        tags = '#' + this.work.tags.join('# #') + '#'
      }
      return tags
    },
    // 关注
    follow(userid) {
      this.emit('follow', [userid, this.update])
      this.update()
    },
    // 取消关注
    unfollow(userid) {
      this.emit('unfollow', [userid, this.update])
      this.update()
    },
    // 喜欢
    praiseIt(workid) {
      if (!workid) return
      const praise = () => {
        if (this.workCount.praise_state) {
          this.workCount.praise_state = 0
          this.workCount.praise_count--
          service.decCount(this.loginUserId, 'work_praise')
        } else {
          this.workCount.praise_state = 1
          this.workCount.praise_count++
          service.incCount(this.loginUserId, 'work_praise')
        }
        this.workCount.praise_count = Math.max(0, this.workCount.praise_count)
      }
      praise()
      service.get('work_praise', workid || 0, (dt, type) => {
        if (type !== 'success') {
          // 失败回滚
          praise()
          this.message(dt, type)
        }
      }, true)
    },
    // 收藏
    favorIt(workid) {
      if (!workid) return
      let albumTip = false
      const favor = () => {
        if (this.workCount.favor_state) {
          this.workCount.favor_state = 0
          this.workCount.favor_count--
          service.decCount(this.loginUserId, 'work_favor')
        } else {
          this.workCount.favor_state = 1
          this.workCount.favor_count++
          service.incCount(this.loginUserId, 'work_favor')
          albumTip = true
        }
        this.workCount.favor_count = Math.max(0, this.workCount.favor_count)
      }
      favor()
      service.get('work_favor', workid, (dt, type) => {
        if (type !== 'success') {
          // 失败回滚
          favor()
          this.message(dt, type)
        } else if (type === 'success' && albumTip) {
          this.myNotify(true, this.$t('i.favorOk'), this.$t('i.addAlbum'), () => {
            this.myNotify(false)
            this.view.albumSelector.workid = workid
            this.view.albumSelector.show = true
          })
        }
      }, true)
    },
    // 分享
    shareIt(workid) {
      if (!workid) {
        this.alert(this.$t('i.publishAndShare'), () => {
          this.emit('publishWork', '')
        })
        return
      }
      this.workCount.share_state = 1
      this.workCount.share_count++
      var clipboard = new ClipboardJS('.clipboard')
      clipboard.on('success', (e) => {
        e.clearSelection()
        this.message(this.$t('i.copyAndShare'), 'success')
        clipboard.destroy()
      })
      service.get('work_share', workid)
      service.incCount(this.loginUserId, 'work_share')
    },
    setImageStyle() {
      if (!this.imgEl || !this.imgEl.width || !this.imgEl.height) return
      const left = (this.width - this.imgEl.width) / 2
      const top = (this.height - this.imgEl.height) / 2
      this.imgEl.style.left = left + 'px'
      this.imgEl.style.top = top + 'px'
      this.imgEl.style.position = 'relative'
    },
    getColorfyWork(colorfyObj, work) {
      work = work || utils.deepClone(this.GRIDY.getFile())
      if (!colorfyObj) return work
      colorfyObj.name = work.name
      colorfyObj.userid = this.loginUserId
      colorfyObj.fillShape = ''
      if (work.canvas.scenes[0].objs.length === 1) {
        // 单对象改写数据
        work.canvas.scenes[0].objs[0].x = 0
        work.canvas.scenes[0].objs[0].y = 0
        work.canvas.scenes[0].objs[0].data = colorfyObj.data
        work.canvas.scenes[0].objs[0].cols = colorfyObj.cols
        work.canvas.scenes[0].objs[0].rows = colorfyObj.rows
      } else {
        // 多对象合并掉
        const newObj = this.GRIDY.createObj(colorfyObj)
        work.canvas.scenes[0].objs = [newObj]
      }
      work.canvas.cols = colorfyObj.cols
      work.canvas.rows = colorfyObj.rows
      return work
    },
    handle(act) {
      let file = utils.deepClone(this.GRIDY.getFile())
      if (act === 'exportPixel' || act === 'exportGridy' || act === 'exportBrick' || act === 'exportAdvance') {
        this.emit('showExportSheet', [file, act, this.opts, this.sceneIdx, this.voxelViewerEl, true])
      } else if (act === 'workActionSheet') {
        this.emit('showActionSheet', [this.work.userid, 'work', this.work])
      } else if (act === 'publishWork') {
        // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
        if (this.work.type >= 2) {
          this.work.voxelBlob = this.voxelViewerEl.getVOXFileBlob()
          const [snapshot, width, height] = this.voxelViewerEl.getSnapshot()
          this.work.snapshot = snapshot
          this.work.width = width
          this.work.height = height
          this.emit('publishWork', [this.work, false])
          return
        }
        if (this.opts.workTypeid === 2) {
          // 改写对象数据
          if (this.sceneObj) {
            file = this.getColorfyWork(this.sceneObj)
          }
          file.type = 1
        } else {
          file.type = 0
        }
        this.emit('publishWork', [file, false])
      } else if (act === 'share') {
        this.$refs['share-url'].click()
      } else if (act === 'pop') {
        this.emit('exportFile', [file, 'pop', 'pop', this.opts, this.sceneIdx])
      }
    },
    getInfo(file) {
      return (file.name || '') + ' ' + this.getWorkTags(file) + ' ' + (file.info || '')
    },
    ease(x) {
      return Math.sqrt(1 - Math.pow(x - 1, 2))
    },
    draw() {
      // this.loading(true)
      this.sceneObj = ''
      const options = { gridSize: this.opts.gridSize, fillShape: this.opts.fillShape, paletteId: this.opts.paletteId, workTypeid: this.opts.workTypeid, darkMatch: false }
      if (this.opts.d3) options.gridSize = 16
      if (this.opts.workTypeid === 2) {
        options.bgId = 'white'
        options.fn = (sceneObj) => {
          this.sceneObj = sceneObj
        }
      }
      this.imgEl.src = this.GRIDY.getSceneImage(this.sceneIdx, options)
    },
    loadAsset(diyType, idx = 0, parentLoading = false) {
      this.loading(true, '', parentLoading, () => {
        // 类型；0=百格画; 1=拼图; 2=图片; 3=3D模型; 4=体素模型; 5=串联积木模型; 6=乐高积木模型; 7=IP形象; 9=其他;
        if (diyType) {
          const workType = (diyType === 'origin_img' || diyType === 'img') ? 2 : diyType === 'd3' ? 3 : diyType === 'vox' ? 4 : diyType === 'chain_brick' ? 5 : diyType === 'lego_brick' ? 6 : diyType === 'views' ? 7 : 9
          this.work.type = workType
          if ((diyType === 'origin_img' || diyType === 'img' || diyType === 'views') && this.assets[diyType] && this.assets[diyType].length) {
            this.data.images = []
            this.data.names = []
            for (const i in this.assets[diyType]) {
              this.data.images.push(this.assets[diyType][i][1])
              this.data.names.push(this.work.paintid + '_' + i)
            }
            this.data.idx = idx
            this.data.isAssets = true
          } else if (diyType === 'd3' || diyType === 'vox' || diyType === 'chain_brick' || diyType === 'lego_brick') {
            this.opts.workTypeid = 0
            const [type, image_url, url] = this.assets[diyType]
            this.work.data = {
              paintid: this.work.paintid,
              type: type,
              image_url: image_url,
              url: url
            }
            delete this.data.images
            delete this.data.names
            delete this.data.idx
            delete this.data.isAssets
          }
          this.data.diyType = diyType
          this.opts.assetid = diyType
          this.textureShow = true
        }
        if (this.work.type > 1 && this.work.data) {
          if (!diyType) {
            this.data.diyType = this.work.data.type
            this.opts.assetid = this.work.data.type
            if ((this.work.type === 7 || this.data.diyType === 'views') && this.work.data) {
              // 构造IP形象图片数据
              const images = []
              const names = []
              // 构造IP形象图片
              if (this.work.data.image_url) {
                images.push(this.work.data.image_url)
                names.push(this.work.name + '_' + this.$t('i.front_image'))
              }
              if (this.work.data.left_image) {
                images.push(this.work.data.left_image)
                names.push(this.work.name + '_' + this.$t('i.left_image'))
              }
              if (this.work.data.right_image) {
                images.push(this.work.data.right_image)
                names.push(this.work.name + '_' + this.$t('i.right_image'))
              }
              if (this.work.data.back_image) {
                images.push(this.work.data.back_image)
                names.push(this.work.name + '_' + this.$t('i.back_image'))
              }
              this.data.images = images
              this.data.names = names
              this.data.idx = 0
              this.data.isAssets = true
            }
          }
          if ((this.work.type === 2 || this.work.type === 7) && this.work.data.image_url) {
            let imageUrl = this.work.data.image_url
            if (this.data.images && this.data.images.length > 0 && idx >= 0) {
              imageUrl = this.data.images[idx]
            }
            this.work.data.image_url = imageUrl
            this.GRIDY.imageLoader(service.getCosUrl(imageUrl, 'paint', this.work.public_at), (base64) => {
              this.imgEl.src = base64
              this.$forceUpdate()
            })
          } else {
            this.load(false)
          }
        } else {
          this.draw()
        }
      })
    },
    // 上一个
    preImage() {
      const scenes = this.data.images
      if (this.sceneIdx === 0) {
        this.sceneIdx = scenes.length - 1
      } else if (this.sceneIdx) {
        this.sceneIdx = this.sceneIdx - 1
      }
      this.loadAsset(this.data.diyType, this.sceneIdx)
    },
    // 下一个
    nextImage() {
      const scenes = this.data.images
      if (this.sceneIdx === scenes.length - 1) {
        this.sceneIdx = 0
      } else if (this.sceneIdx < scenes.length - 1) {
        this.sceneIdx = this.sceneIdx + 1
      }
      this.loadAsset(this.data.diyType, this.sceneIdx)
    },
    submit() {
      this.stop()
      setTimeout(() => {
        const file = this.GRIDY.getFile()
        file.fillShape = this.opts.fillShape
        this.config.fn && this.config.fn(file, 'JSON')
      }, 10)
    },
    // 开始播放
    start() {
      this.playing = true
      this.count = 0
      this.play()
    },
    // 上一个
    pre() {
      const scenes = this.work.canvas.scenes
      if (this.sceneIdx === 0) {
        this.sceneIdx = scenes.length - 1
      } else if (this.sceneIdx) {
        this.sceneIdx = this.sceneIdx - 1
      }
      this.draw()
    },
    // 下一个
    next() {
      const scenes = this.work.canvas.scenes
      if (this.sceneIdx === scenes.length - 1) {
        this.sceneIdx = 0
      } else if (this.sceneIdx < scenes.length - 1) {
        this.sceneIdx = this.sceneIdx + 1
      }
      this.draw()
    },
    // 播放场景
    play() {
      const scenes = this.work.canvas.scenes
      if (scenes.length < 2 || !this.playing) {
        return
      }
      this.count++
      if (this.sceneIdx === scenes.length - 1) {
        this.sceneIdx = 0
      } else if (this.sceneIdx < scenes.length - 1) {
        this.sceneIdx = this.sceneIdx + 1
      }
      this.draw()
      this.work.rate = this.work.rate || 12
      this.work.loop = this.work.loop || 0
      if (this.work.loop && this.count / scenes.length >= this.work.loop) {
        this.count = 0
        this.playing = false
        return
      }
      this.sto = setTimeout(this.play, 1000 / this.work.rate)
    },
    // 停止播放
    stop() {
      this.playing = false
      this.count = 0
      this.sceneIdx = 0
      this.draw()
      if (this.sto) clearTimeout(this.sto)
    }
  }
}
</script>
